export const SalesCampaignPlanningStorageKey = 'sales-campaign-planning';

export const SalesCampaignPlanningColumnStateStorageKey = 'sales-campaign-planning-column-state';
